;(function($) {


    // Ajax loader
    var url, content,
        slug = window.location.pathname.split('/').slice(-1)[0]

    $('.js-ajaxLoader').each(function () {
        content = $(this)
        url = content.attr('data-url')

        $.ajax({
            url: url,
            data: { slug },
            success: function (result) {
                content.html(result)
            }
        })
    })


}(jQuery));